import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFormFields, isFormValid, onTextChange, onDropDownChange } from '../../../utile/formHelper';
import _, { cloneDeep } from 'lodash';
import { baseUrlAdmin } from '../../../store/apiConstants';
import { Button } from 'primereact/button';
import Service from './../../services';
import { Toast } from 'primereact/toast';
import { getBoardsData, getBranchesLatest } from '../../../store/actions';
import { userAssignedBoards } from '../../../store/selectors/userAssignedBoards';
import withRouter from '../../lib/withRouter';
import LoadingComponent from '../../loadingComponent';
import { DeleteIconClasset, LocationMarker, MailIcon } from '../../svgIcons';
import ClassetInputText from '../../../classetComponents/classetInputText';
import ClassetDropdown from '../../../classetComponents/classetDropDown';
import ClassetMultiSelect from '../../../classetComponents/classetMultiSelect';
import ClassetCalendar from '../../../classetComponents/classetCalender';
const createRouteFields = require('./createRoute.json');
let formFields = createRouteFields;

class CreateRoute extends Component {
    constructor(props) {
        super(props);
        this.formFields = getFormFields(createRouteFields);
        this.state = {
            route: this.props?.dataForAddRoutes?._id ? this.props?.dataForAddRoutes : this.formFields.data,
            formValidations: this.formFields.formValidations,
            stopsList: [],
            focused: false,
            inputFocused: false,
            boards: [],
            classes: [],
            academicYears: [],
            vehicleDropdowns: [],
            feeTypeDropDown: [],
            stops: [{ id: 1, name: '', latitude: '', longitude: '', landmark: '', pickUpTime: '', dropTime: '', transportFee: '' }],
            isShowCreateSuccess: false,
            hideUpdateButton: false
        };
        this.service = new Service();
    }

    componentDidMount() {
        if (this.props.dataForAddRoutes?._id) {
            const modifiedStops = this.props.dataForAddRoutes?.stops.map((stop) => {
                return {
                    ...stop,
                    dropTime: stop.dropTime || '',
                    pickUpTime: stop.pickUpTime || '',
                    isExisting: true,
                    latitude: stop.latitude || '',
                    longitude: stop.longitude || '',
                    landmark: stop.landmark || ''
                };
            });
            // Stops come pre-sorted from backend by pickUpTime

            this.setState(
                {
                    route: {
                        branchId: this.props.dataForAddRoutes.branchId,
                        routeName: this.props.dataForAddRoutes.routeName,
                        routeNo: this.props.dataForAddRoutes.routeNo
                    },
                    stops: modifiedStops
                },
                () => this.getDropdownsData(true)
            );
        }
    }

    getDropdownsData = async (editMode) => {
        this.setState({
            isLoading: true
        });
        const academicYear = localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/transport-route/meta-data?academicYear=${academicYear}`;
        let payload = {
            branchId: this.state.route.branchId
        };
        try {
            const res = await this.service.post(url, payload, true);
            if (res?.res?.status && res.status) {
                const vehicles = res?.res?.data?.vehicles?.map((vehicles) => ({
                    label: `${vehicles.vehicleName} - ${vehicles.vehicleRegistrationNo}`,
                    value: vehicles._id,
                    registrationNumber: vehicles.vehicleRegistrationNo
                }));
                const fee = res?.res?.data?.feePlans?.map((fee) => ({
                    label: fee.feeName,
                    value: fee._id
                }));

                // In edit mode, ensure current vehicle is in the dropdown even if filtered out
                let finalVehicles = vehicles || [];
                if (editMode && this.props.dataForAddRoutes?.vehicleId) {
                    const currentVehicleExists = finalVehicles.some(v => v.value === this.props.dataForAddRoutes.vehicleId);
                    if (!currentVehicleExists && this.props.dataForAddRoutes?.vehicleName) {
                        finalVehicles = [
                            {
                                label: `${this.props.dataForAddRoutes.vehicleName} - ${this.props.dataForAddRoutes.vehicleRegistrationNo}`,
                                value: this.props.dataForAddRoutes.vehicleId,
                                registrationNumber: this.props.dataForAddRoutes.vehicleRegistrationNo
                            },
                            ...finalVehicles
                        ];
                    }
                }

                this.setState({ vehicleDropdowns: finalVehicles, feeTypeDropDown: fee, isLoading: false }, () => {
                    if (editMode) {
                        this.setState((prevState) => {
                            return {
                                route: {
                                    ...prevState.route,
                                    vehicleId: this.props.dataForAddRoutes.vehicleId
                                },
                                isLoading: false
                            };
                        });
                    }
                });
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occured', life: 3000 });
            }
        } catch (e) {
            this.setState({
                isLoading: false
            });
            this.toast.show({ severity: 'error', summary: 'Error', detail: 'some Error', life: 3000 });
        }
    };

    isValid = (value) => value !== undefined && value !== null && value !== '';
    hasDifferences(oldItem, newItem) {
        const differences = {};
        // Fields to compare for changes
        const fieldsToCompare = ['stopName', 'pickUpTime', 'dropTime', 'latitude', 'longitude', 'landmark', 'transportFee'];

        fieldsToCompare.forEach((key) => {
            const oldValue = oldItem[key]?.toString?.() || oldItem[key] || '';
            const newValue = newItem[key]?.toString?.() || newItem[key] || '';
            if (oldValue !== newValue) {
                differences[key] = newItem[key];
            }
        });

        return Object.keys(differences).length > 0 ? differences : null;
    }

    onCreateRoute = async () => {

        const result = [];
        const academicYear = localStorage.getItem('userAcademicYear');
        const fieldData = cloneDeep(this.state.route);
        let vehicle = this.state.vehicleDropdowns.find((el) => el.value == fieldData?.vehicleId);
        const { stops } = this.state;
        const allFieldsFilled = stops.every(stop => {
            return stop.stopName && stop.latitude && stop.longitude && stop.pickUpTime && stop.dropTime;
        });
        let isTimeValid = stops.every((stop) => {
            return this.isPickUpTimeLessThanDropTime(stop);
        });
        if (allFieldsFilled && isTimeValid) {
            if (this.props?.dataForAddRoutes?._id) {
                const stopData = this.state?.stops || [];
                let stopsForApi = stopData?.map((stop, index) => {
                    let stopObject = {

                        stopName: stop.stopName,
                        pickUpTime: stop.pickUpTime,
                        dropTime: stop.dropTime,
                        latitude: stop.latitude,
                        longitude: stop.longitude,
                        landmark: stop.landmark,
                        transportFee: stop.transportFee ? Number(stop.transportFee) : Number(this.state.route.commonTransportFee || 0),
                        sequence: index + 1
                    };

                    if (stop._id) {
                        stopObject._id = stop._id;
                    }
                    return stopObject;
                });

                stopsForApi.forEach((newItem) => {
                    if (newItem._id === undefined) {
                        result.push(newItem);
                    } else {
                        const oldItem = this.props?.dataForAddRoutes?.stops.find((item) => item._id === newItem._id);
                        if (oldItem) {
                            const differences = this.hasDifferences(oldItem, newItem);
                            if (differences) {
                                result.push({ _id: newItem._id, ...newItem });
                            }
                        }
                    }
                });
                stopsForApi = result;

                // Check if there are any new or modified stops to submit
                if (stopsForApi.length === 0) {
                    this.toast.show({ severity: 'warn', summary: 'Warning', detail: 'No new or modified stops to submit for approval', life: 3000 });
                    return;
                }
                // Backend will sort stops by pickUpTime when saving
                const allValid = stopsForApi?.every((stop) => {
                    const requiredFields = ['stopName', 'pickUpTime', 'dropTime'];

                    // Check required fields
                    const hasRequiredFields = requiredFields.every(field => this.isValid(stop[field]));

                    // Check location
                    const hasLocation = this.isValid(stop.latitude) && this.isValid(stop.longitude);

                    // Transport fee can be 0, so check for undefined/null only
                    const hasValidFee = stop.transportFee !== undefined && stop.transportFee !== null;

                    // Landmark is optional, so don't validate it

                    return hasRequiredFields && hasLocation && hasValidFee;
                });
                if (!allValid) {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Error', detail: 'Please enter all the required fields', life: 3000 });
                    return;
                }
                const payloadData = {
                    routeId: this.props?.dataForAddRoutes?._id,
                    routeNo: this.props?.dataForAddRoutes?.routeNo,
                    stops: stopsForApi || [],
                    academicYear: academicYear,
                    branchId: this.props?.dataForAddRoutes?.branchId,
                    registration_number: fieldData?.registration_number,
                    vehicleName: vehicle?.label,
                    vehicleRegistrationNo: this.props?.dataForAddRoutes?.vehicleRegistrationNo,
                    routeName: this.props?.dataForAddRoutes.routeName
                };
                let url = `${baseUrlAdmin}/transport-stops-approval/raise-stop-approvals`;
                try {
                    this.setState({
                        isLoading: true
                    });
                    const res = await this.service.post(url, payloadData, true);
                    if (res?.res?.status && res.status) {
                        this.setState({
                            isLoading: false
                        });
                        // Use parent toast since this dialog will close
                        if (this.props.toastMessage) {
                            this.props.toastMessage.show({ severity: 'success', summary: 'Success', detail: 'Stop(s) sent for approval successfully', life: 3000 });
                        } else {
                            this.toast.show({ severity: 'success', summary: 'Success', detail: 'Stop(s) sent for approval successfully', life: 3000 });
                        }
                        setTimeout(() => {
                            this.props.onCancel();
                            this.props.getRoutesData();
                        }, 500);
                    } else {
                        this.setState({
                            isLoading: false
                        });
                        this.toast.show({ severity: 'error', summary: 'Error', detail: res?.errMessage || 'Some error occured', life: 3000 });
                    }
                } catch (e) {
                    this.setState({
                        isLoading: false
                    });
                    console.log(e);
                    this.toast.show({ severity: 'error', summary: e.message || e, detail: 'Some error occured', life: 3000 });
                }
            } else {
                let body = cloneDeep(this.state.route);
                let vehicle = this.state.vehicleDropdowns.find((el) => el.value == body?.vehicleId);
                const stopData = this.state?.stops || [];
                const stopsForApi = stopData?.map((stop, index) => ({
                    areaName: stop.areaName,
                    stopName: stop.stopName,
                    pickUpTime: stop.pickUpTime,
                    dropTime: stop.dropTime,
                    latitude: stop.latitude,
                    longitude: stop.longitude,
                    landmark: stop.landmark,
                    transportFee: stop?.transportFee || 0,
                    sequence: index + 1
                }));
                // Backend will sort stops by pickUpTime when saving
                const allValid = stopsForApi?.every((stop) => {
                    const requiredFields = ['stopName', 'pickUpTime', 'dropTime'];

                    // Check required fields
                    const hasRequiredFields = requiredFields.every(field => this.isValid(stop[field]));

                    // Check location
                    const hasLocation = this.isValid(stop.latitude) && this.isValid(stop.longitude);

                    // Transport fee can be 0, so check for undefined/null only
                    const hasValidFee = stop.transportFee !== undefined && stop.transportFee !== null;

                    // Landmark is optional, so don't validate it

                    return hasRequiredFields && hasLocation && hasValidFee;
                });
                if (!allValid) {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Error', detail: 'Please enter all the required fields', life: 3000 });
                    return;
                }
                const formStatus = isFormValid(createRouteFields, this.formFields.formValidations, body);

                if (!formStatus.formValidations.isFormValid) {
                    this.setState({ formValidations: formStatus.formValidations });
                } else {
                    const payload = {
                        routeName: body?.routeName,
                        stops: stopsForApi || [],
                        academicYear: academicYear,
                        branchId: body?.branchId,
                        routeNo: body?.routeNo
                    };

                    // Add vehicleId only if selected (now optional in V2)
                    if (body?.vehicleId) {
                        payload.vehicleId = body.vehicleId;
                        payload.registration_number = body?.registration_number;
                        payload.vehicleName = vehicle?.label;
                    }
                    let url = `${baseUrlAdmin}/transport-route-approval/raise-route-approvals`;

                    try {
                        this.setState({
                            isLoading: true
                        });
                        const { stops } = this.state;
                        const allFieldsFilled = stops.every(stop =>
                            stop.stopName && stop.latitude && stop.longitude && stop.pickUpTime && stop.dropTime
                        );
                        let isTimeValid = stops.every((stop) => {
                            return this.isPickUpTimeLessThanDropTime(stop);
                        });
                        if (allFieldsFilled && isTimeValid) {

                        } else {
                            if (!allFieldsFilled) {
                                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Please fill all the fields in existing stops', life: 3000 });
                            } else {
                                this.toast.show({ severity: 'error', summary: 'Error', detail: 'PickUp time must be earlier than Drop time.', life: 3000 });
                            }
                        }
                        const res = await this.service.post(url, payload, true);
                        if (res?.res?.status && res.status) {
                            this.setState({
                                isLoading: false
                            });
                            this.props.toastMessage.show({ severity: 'success', summary: 'Created successfully', detail: res?.res?.message || res?.errMessage, life: 3000 });
                            this.props.onCancel();
                            this.props.getRoutesData();
                        } else {
                            this.setState({
                                isLoading: false
                            });
                            this.props.toastMessage.show({ severity: 'error', summary: 'Error', detail: res?.errMessage, life: 3000 });
                        }
                    } catch (e) {
                        this.setState({
                            isLoading: false
                        });
                        console.log(e);
                        this.props.toastMessage.show({ severity: 'error', summary: e.message || e, detail: 'Some error occured', life: 3000 });
                    }
                }
            }
        } else {
            if (!allFieldsFilled) {
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Please fill all the fields in existing stops', life: 3000 });
            } else {
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'PickUp time must be earlier than Drop time.', life: 3000 });
            }
            this.setState({
                isLoading: false
            });
        }

    };

    isPickUpTimeLessThanDropTime = (stop) => {
        if (stop.pickUpTime && stop.dropTime) {
            const [pickHour, pickMin] = stop.pickUpTime.split(':').map(Number);
            const [dropHour, dropMin] = stop.dropTime.split(':').map(Number);
            const pickUpMinutes = pickHour * 60 + pickMin;
            const dropMinutes = dropHour * 60 + dropMin;
            return pickUpMinutes < dropMinutes;
        }
        return true;
    };
    addStop = () => {
        const { stops } = this.state;
        const allFieldsFilled = stops.every(stop =>
            stop.stopName && stop.latitude && stop.longitude && stop.pickUpTime && stop.dropTime
        );
        let isTimeValid = stops.every((stop) => {
            return this.isPickUpTimeLessThanDropTime(stop);
        });
        if (allFieldsFilled && isTimeValid) {
            const newStop = {
                id: this.state.stops.length + 1,
                areaName: '',
                stopName: "",
                latitude: "",
                longitude: "",
                landmark: "",
                pickUpTime: '',
                dropTime: '',
                transportFee: this.state.route.commonTransportFee && this.state.route.commonTransportFee !== 0 ? this.state.route.commonTransportFee : ''
            };
            this.setState((prevState) => ({
                stops: [...prevState.stops, newStop]
            }));
        } else {
            if (!allFieldsFilled) {
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Please fill all the fields in existing stops', life: 3000 });
            } else {
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'PickUp time must be earlier than Drop time.', life: 3000 });
            }
        }
    };


    removeStop = (index) => {
        if (this.state.stops.length > 1) {
            const stops = this.state.stops.filter((_, i) => i !== index);
            this.setState({ stops });
        }
    };

    handleInputChange = (index, field, value) => {
        const stops = [...this.state.stops];

        stops[index][field] = value;
        this.setState({ stops });
    };

    render() {
        const { route, formValidations, stops } = this.state;
        const { onCancel } = this.props;
        return (
            <>
                <div className="mt-3">
                    <div className="grid" style={{ gap: '0.2rem', margin: '0' }}>
                        <div className="col" style={{ padding: '0.2rem' }}>
                            <p className="add-vehicle-field-label">
                                Branch<span className="ma-required">*</span>
                            </p>
                            <div className="flex">
                                <ClassetDropdown
                                    // icon={<MailIcon />}
                                    optionLabel="name"
                                    optionValue="key"
                                    width="16vw"
                                    value={route?.branchId}
                                    options={this.props.branchData}
                                    disabled={this.props?.dataForAddRoutes?._id ? true : false}
                                    onChange={async (e) => {
                                        await onDropDownChange(e.target.value, 'branchId', this, formFields, route, formValidations, 'route', 'formValidations');
                                        await this.getDropdownsData(false);
                                    }}
                                    placeholder={
                                        <div className="flex justify-content-start  align-items-center">
                                            <span className="">Select Branch</span>
                                        </div>
                                    }
                                />
                            </div>
                            {formValidations && !formValidations.fields['branchId'].isValid && <p className="p-error">{formValidations.fields['branchId'].errorMsg}</p>}
                        </div>

                        <div className="col" style={{ padding: '0.2rem' }}>
                            <p className="add-vehicle-field-label">
                                Route Name<span className="ma-required">*</span>
                            </p>
                            <div className="flex">
                                <ClassetInputText
                                    style={{ border: 'none' }}
                                    disabled={this.props?.dataForAddRoutes?._id ? true : false}
                                    width="16vw"
                                    value={route.routeName}
                                    onChange={(e) => onTextChange(e.target.value, 'routeName', this, formFields, route, formValidations, 'route', 'formValidations')}
                                    placeholder="Route Name"
                                />
                            </div>
                            {!this.props?.dataForAddRoutes?._id && formValidations && !formValidations.fields['routeName'].isValid && <p className="p-error">{formValidations.fields['routeName'].errorMsg}</p>}
                        </div>
                        <div className="col" style={{ padding: '0.2rem' }}>
                            <p className="add-vehicle-field-label">
                                Route No<span className="ma-required">*</span>
                            </p>
                            <div className="flex">
                                <ClassetInputText
                                    onClick={this.handleInputFocus}
                                    width="16vw"
                                    onBlur={this.handleInputBlur}
                                    style={{ border: 'none' }}
                                    disabled={this.props?.dataForAddRoutes?._id ? true : false}
                                    value={route.routeNo}
                                    onChange={(e) => onTextChange(e.target.value, 'routeNo', this, formFields, route, formValidations, 'route', 'formValidations')}
                                    placeholder="Route No"
                                />
                            </div>
                            {!this.props?.dataForAddRoutes?._id && formValidations && !formValidations.fields['routeNo'].isValid && <p className="p-error">{formValidations.fields['routeNo'].errorMsg}</p>}
                        </div>
                    </div>
                    <div style={{ height: '2px', backgroundColor: '#B1B1B1' }}></div>

                    {this.state.stops.map((stop, index) => (
                        <div className='flex'>
                            <div key={index} className="grid lg:col-11 mx-0 mt-5 border-top-1 border-left-2 border-right-1 border-bottom-2 border-300 border-round-lg overflow-hidden">
                                {/*  <div className="col-12 md:col-3">
                                    <p className="add-vehicle-field-label">
                                        Area Name<span className="ma-required">*</span>
                                    </p>
                                    <ClassetInputText width="100%" value={stop.areaName} onChange={(e) => this.handleInputChange(index, 'areaName', e.target.value)} placeholder="Area Name" />
                                </div> */}

                                <div className="col-12 md:col-3">
                                    <p className="add-vehicle-field-label">
                                        Stop Name<span className="ma-required">*</span>
                                    </p>
                                    <ClassetInputText width="100%" value={stop.stopName} onChange={(e) => this.handleInputChange(index, 'stopName', e.target.value)} placeholder="Stop Name" />
                                </div>

                                <div className="col-12 md:col-3">
                                    <p className="add-vehicle-field-label">
                                        Latitude<span className="ma-required">*</span>
                                    </p>
                                    <ClassetInputText
                                        width="100%"
                                        value={stop.latitude}
                                        onChange={(e) => this.handleInputChange(index, 'latitude', e.target.value)}
                                        placeholder="Latitude"
                                    />
                                </div>

                                <div className="col-12 md:col-3">
                                    <p className="add-vehicle-field-label">
                                        Longitude<span className="ma-required">*</span>
                                    </p>
                                    <ClassetInputText
                                        width="100%"
                                        value={stop.longitude}
                                        onChange={(e) => this.handleInputChange(index, 'longitude', e.target.value)}
                                        placeholder="Longitude"
                                    />
                                </div>

                                <div className="col-12 md:col-3">
                                    <p className="add-vehicle-field-label">
                                        Landmark
                                    </p>
                                    <ClassetInputText width="100%" value={stop.landmark} onChange={(e) => this.handleInputChange(index, 'landmark', e.target.value)} placeholder="Landmark" />
                                </div>

                                <div className="col-12 md:col-3">
                                    <p className="add-vehicle-field-label">
                                        Pick up time<span className="ma-required">*</span>
                                    </p>
                                    <input
                                        type="time"
                                        className="add-vehicle-field-input w-full"
                                        style={{ height: '48px', padding: '0 12px', border: '1px solid #ced4da', borderRadius: '6px' }}
                                        value={stop.pickUpTime || ''}
                                        onChange={(e) => this.handleInputChange(index, 'pickUpTime', e.target.value)}
                                    />
                                </div>

                                <div className="col-12 md:col-3">
                                    <p className="add-vehicle-field-label">
                                        Drop time<span className="ma-required">*</span>
                                    </p>
                                    <input
                                        type="time"
                                        className="add-vehicle-field-input w-full"
                                        style={{ height: '48px', padding: '0 12px', border: '1px solid #ced4da', borderRadius: '6px' }}
                                        value={stop.dropTime || ''}
                                        onChange={(e) => this.handleInputChange(index, 'dropTime', e.target.value)}
                                    />
                                </div>
                            </div>
                            {this.props?.dataForAddRoutes?._id ? <></> : <div className='flex align-self-center align-items-center justify-content-center mx-4 md:mt-5 lg:mt-2 pt-1' >
                                <Button style={{ borderRadius: 50, backgroundColor: '#C6CED2', border: 'none', color: '#fff' }} className=" p-3 font-semibold ml-4 mt-4" onClick={() => this.removeStop(index)}>
                                    <DeleteIconClasset height={"22"} />
                                </Button>

                            </div>}

                        </div>

                    ))}
                    <Button label="Add Stop" icon={'pi pi-plus-circle text-black text-lg '} style={{ borderRadius: 12, backgroundColor: '#F4F5F6', border: 'none', color: 'black' }} className=" p-3 font-semibold ml-4 mt-4" onClick={this.addStop} />
                </div >

                <div className="flex justify-content-center mt-8">
                    <Button label={this.props?.dataForAddRoutes?._id ? 'Add Stop(s)' : 'Add Route'} className="confirmDialogAcceptBtn px-6 mr-5 w-19rem" onClick={this.onCreateRoute} />
                    <Button label="Cancel" className="confirmDialogCancelBtn" onClick={onCancel} />
                </div>
                <Toast ref={(el) => (this.toast = el)} position="bottom-right" />
                {
                    (this.state.isLoading || this.props.isBranchLoading || this.props.isLoading) && (
                        <>
                            <LoadingComponent />
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoardsWithoutMeluha'),
    isLoading: state.boardsData.loading,
    isBranchLoading: state.branchDataLatest.isLoading,
    branchLevels: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.levels,
    branchData:
        (state.branchDataLatest &&
            state.branchDataLatest.data &&
            state.branchDataLatest.data.data.filter((each) => {
                if (each.level == 1) {
                    return { ...each };
                }
            })) ||
        [],
    _id: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data._id
});

export default connect(mapStateToProps, {
    getBoardsData,
    getBranchesLatest
})(withRouter(CreateRoute));
